<template>
  <div class="container-fluid Background"
  :style="{ backgroundImage: 'url(' + backgroundImg + ')' }"></div>
</template>

<script>
export default {
  name: 'background',

  props: {
    backgroundImg: String
  }
}
</script>


<style lang="scss" scoped>
@import './../../assets/_variables.scss';
.Background {
  background-color: $transparentDarkgray;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  top: 0;
  min-height: 100vh;
  height: 100vh;
  z-index: $z-background;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/background.vue